var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamworkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 79,
    viewBox: "0 0 116 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.358 39.2147L112.202 33.3167C112.66 33.0884 113.067 32.7708 113.401 32.3828C113.734 31.9947 113.986 31.5439 114.142 31.0569C114.299 30.5699 114.356 30.0565 114.311 29.547C114.266 29.0375 114.12 28.5422 113.881 28.0901L102.085 5.50519C101.624 4.61761 100.831 3.94812 99.8793 3.64271C98.9271 3.3373 97.8928 3.42075 97.0019 3.87486L85.0142 9.86873M100.358 39.2147L85.0142 9.86873M100.358 39.2147L92.6863 48.2295M85.0142 9.86873L65.4982 9.86873C65.0001 9.86698 64.5065 9.96349 64.0457 10.1527C63.5849 10.342 63.166 10.6202 62.8129 10.9716L44.0162 29.7204C43.6324 30.1144 43.3366 30.5854 43.1485 31.1023C42.9604 31.6192 42.8843 32.1701 42.9251 32.7186C42.9659 33.2672 43.1227 33.8008 43.3852 34.2841C43.6477 34.7675 44.0099 35.1896 44.4477 35.5225L47.0371 37.4885C49.6962 39.4731 52.9255 40.5454 56.2436 40.5454C59.5618 40.5454 62.7911 39.4731 65.4502 37.4885L71.5879 32.8852L92.6863 48.2295M15.9649 38.7352L4.12101 32.7893C3.66498 32.5658 3.25854 32.2528 2.92587 31.8691C2.59319 31.4854 2.34108 31.0387 2.18451 30.5555C2.02794 30.0724 1.97012 29.5627 2.01448 29.0568C2.05884 28.5509 2.20448 28.0591 2.44273 27.6106L14.2387 5.02568C14.7001 4.13874 15.4896 3.467 16.439 3.15352C17.3883 2.84005 18.4226 2.90961 19.3215 3.3474L31.3092 9.34127L15.9649 38.7352ZM15.9649 38.7352L42.194 59.2102C42.6032 59.543 43.0766 59.7879 43.5846 59.9295L71.3961 66.8824C72.0397 67.0214 72.7074 67.0024 73.3421 66.827C73.9768 66.6516 74.5595 66.3251 75.0404 65.8754L92.6863 48.2295M31.5969 9.34127L56.1957 2.14863C57.0697 1.89798 58.0044 1.96595 58.833 2.34043L75.424 9.86873M50.4895 77L36.0563 73.3557C35.4682 73.2229 34.9236 72.9423 34.4739 72.5406L23.637 63.1422",
    stroke: "url(#paint0_linear_554_1434)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_554_1434",
    x1: 58.163,
    y1: 2,
    x2: 58.163,
    y2: 77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EAFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#4063B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#704BA5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamworkIcon);
export default __webpack_public_path__ + "static/media/teamwork_icon.3ffe8ee78ce599767cec9f1ac29e45bd.svg";
export { ForwardRef as ReactComponent };